export default "__VITE_ASSET__BOWYhz4Q__"